import {doSuccessFailureActions} from '../_utils/actions.js';

export const MODIFY_SKIRESORT = doSuccessFailureActions('MODIFY_SKIRESORTS');
export const ADD_SKIRESORT = doSuccessFailureActions('ADD_SKIRESORTS');
export const DELETE_SKIRESORT = doSuccessFailureActions('DELETE_SKIRESORTS');
export const CHANGE_DATES = doSuccessFailureActions('CHANGE_DATES');

// MODIFY

export function modifySkiresort(payload) {
  return {type: MODIFY_SKIRESORT.do, payload: payload}
}

export function modifySkiresortSuccess(payload) {
  return {type: MODIFY_SKIRESORT.success, payload: payload}
}

export function modifySkiresortFailure(payload, err) {
  return {type: MODIFY_SKIRESORT.failure, payload: payload, err: err}
}

// CHANGE DATES OF ALL SKI RESORT

export function changeDates(payload) {
  return {type: CHANGE_DATES.do, payload: payload}
}

export function changeDatesSuccess(payload) {
  return {type: CHANGE_DATES.success, payload: payload}
}

export function changeDatesFailure(payload, err) {
  return {type: CHANGE_DATES.failure, payload: payload, err: err}
}


// ADD

export function addSkiresort(payload) {
  return {type: ADD_SKIRESORT.do, payload: payload}
}

export function addSkiresortSuccess(payload) {
  return {type: ADD_SKIRESORT.success, payload: payload}
}

export function addSkiresortFailure(payload, err) {
  return {type: ADD_SKIRESORT.failure, payload: payload, err: err}
}

// DELETE

export function deleteSkiresort(id) {
  return {type: DELETE_SKIRESORT.do, id};
}

export function deleteSkiresortSuccess(id) {
  return {type: DELETE_SKIRESORT.success, id};
}

export function deleteSkiresortFailure(id, err) {
  return {type: DELETE_SKIRESORT.failure, id, err};
}



// WEBPACK FOOTER //
// ./src/redux/skiresorts/actions.js